import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel/Carousel';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-page">
      {/* Carousel remplace le hero */}
      <Carousel />

      {/* Section Schedule */}
      <section className="section schedule-section">
        <div className="container">
          <h2 className="section-title">SCHEDULE</h2>

          <div className="schedule-preview">
            <div className="schedule-day">
              <h3>Monday, June 1, 2026</h3>
              <ul>
                <li><strong>09:30-12:30</strong> APC — ADAGP Auditorium</li>
                <li><strong>TBC</strong> CAF — CISAC</li>
                <li><strong>14:00-17:30</strong> APC — ADAGP Auditorium</li>
                <li><strong>TBC</strong> CAF — CISAC</li>
              </ul>
            </div>

            <div className="schedule-day">
              <h3>Tuesday, June 2, 2026</h3>
              <ul>
                <li><strong>10:00-12:00</strong> APC/CLC — ADAGP Auditorium</li>
                <li><strong>09:30-12:30</strong> DLVRG — SACD</li>
                <li><strong>10:00-12:00</strong> BIEM MC — SACEM, Darius Milhaud Room</li>
                <li><strong>14:00-15:00</strong> APMA ExCo — ADAGP Library</li>
                <li><strong>14:00-16:00</strong> BIEM GA — SACEM Auditorium</li>
              </ul>
            </div>

            <div className="schedule-day">
              <h3>Wednesday, June 3, 2026</h3>
              <ul>
                <li><strong>09:30-13:00</strong> Board — SACEM</li>
                <li><strong>TBC</strong> AAPA — CISAC</li>
                <li><strong>14:30-17:00</strong> Board — SACEM</li>
              </ul>
            </div>

            <div className="schedule-day highlight">
              <h3>Thursday, June 4, 2026</h3>
              <ul>
                <li><strong>09:30-13:00</strong> General Assembly — Pavillon Cambon</li>
                <li><strong>14:30-17:00</strong> General Assembly — Pavillon Cambon</li>
              </ul>
            </div>

            <div className="schedule-day">
              <h3>Friday, June 5, 2026</h3>
              <ul>
                <li><strong>TBC</strong> CIAM ExCo — SACEM</li>
                <li><strong>09:30-12:30</strong> MRG — Venue TBC</li>
                <li><strong>TBC</strong> CIAM ExCo — SACEM</li>
              </ul>
            </div>
          </div>

          <div className="schedule-cta">
            <Link to="/schedule" className="btn btn-primary">
              View Complete Schedule
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Registration */}
      <section className="section registration-cta">
        <div className="container">
          <h2>JOIN THE MEETINGS</h2>
          <p>Register for CISAC GA 2026</p>
          <Link to="/registration" className="btn btn-large btn-registration">
            Go to Registration
          </Link>
        </div>
      </section>

      {/* Section Accommodation */}
      <section className="section accommodation-section">
        <div className="container">
          <div className="accommodation-content">
            <div className="accommodation-text">
              <h2>ACCOMMODATION</h2>
              <p>
                We have secured special rates at carefully selected hotels near the venue
                in the heart of Paris. Book your accommodation early to benefit from
                preferential pricing and guarantee availability.
              </p>
              <p>
                All hotels are within walking distance or a short metro ride from
                Pavillon Cambon, ensuring convenient access to all meetings and events.
              </p>
              <Link to="/accommodation" className="btn btn-primary">
                Go to Accommodation
              </Link>
            </div>
            <div className="accommodation-image">
              <img
                src="https://images.unsplash.com/photo-1549294413-26f195200c16?w=800&h=600&fit=crop"
                alt="Paris Accommodation"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
